export const CATEGORY_PRESETS = [
  'lapsi',
  'teini',
  'käyttäjä',
  'vanhempi',
  'pappa',
  'mummo',
  'kaveri',
];

export const CATEGORY_LABELS = {
  lapsi: 'Lapsi',
  teini: 'Teini',
  käyttäjä: 'Käyttäjä',
  vanhempi: 'Vanhempi',
  pappa: 'Pappa',
  mummo: 'Mummo',
  kaveri: 'Kaveri',
};

export function getCategoryLabel(user) {
  if (!user) return '';
  if (user.category) {
    return CATEGORY_LABELS[user.category] || user.category;
  }
  return user.type === 'parent' ? 'Vanhempi' : 'Käyttäjä';
}
